<div *ngIf="!currentEmployee.pendingRetirementLoanRequests.pending; else showRetirementLoanPending">
<div class="row py-5 mx-3  border-bottom">

  <div class="col-md-4">
    <button [ngClass]="'btn btn-block'" [class.btn-primary]="showLoanStatementReport" [class.btn-outline-secondary]="!showLoanStatementReport" (click)="loanStatementReport()">
      Estado de Cuenta
    </button>
  </div>

  <div class="col-md-4" *ngIf="currentEmployee">

    <div matTooltip="Existe un candado en este momento por periodo de pagos, inténtelo mas tarde." aria-label="mensaje" matTooltipPosition="above" [matTooltipDisabled]="!shouldAllowRestructuring(currentEmployee, originalLoan)">

      <button [ngClass]="'btn btn-block'" [class.btn-primary]="showLoanRestructuring" [class.btn-outline-secondary]="!showLoanRestructuring" (click)="loanRestructuring()" [disabled]="shouldAllowRestructuring(currentEmployee, originalLoan)" [matBadgeHidden]="!shouldAllowRestructuring(currentEmployee, originalLoan)" matBadge="?" matBadgePosition="after" matBadgeColor="accent" matBadgeSize="large">
        Reestructuración De Préstamo
      </button>

    </div>

  </div>

  <div class="col-md-4" *ngIf="currentEmployee">

    <div matTooltip="Existe un candado en este momento por periodo de pagos, inténtelo mas tarde." aria-label="mensaje" matTooltipPosition="above" [matTooltipDisabled]="!logicService.isTodayAPayrollDayForEmployee(currentEmployee)">

      <button [ngClass]="'btn btn-block'" [class.btn-primary]="showLoanAdvancePayment" [class.btn-outline-secondary]="!showLoanAdvancePayment" (click)="loanAdvancePayment()" [disabled]="logicService.isTodayAPayrollDayForEmployee(currentEmployee)" [matBadgeHidden]="!logicService.isTodayAPayrollDayForEmployee(currentEmployee)" matBadge="?" matBadgePosition="after" matBadgeColor="accent" matBadgeSize="large">
        Pago Anticipado De Préstamo
      </button>

    </div>

  </div>

</div>

<div class="mt-3" *ngIf="showLoanStatementReport">

  <h5 class="mt-1 mb-4">Datos Iniciales de su Préstamo:</h5>

  <div class="row">

    <div class="col-md-4">
      <mat-form-field>
        <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
        <input matInput placeholder="Importe Inicial:" [value]="(originalLoan.requestedAmount | number: '.2')" type="text" disabled>
      </mat-form-field>
    </div>

    <!--div class="col-md-4">
      <mat-form-field>
        <input matInput placeholder="Fecha del Primer Descuento:"
          [value]="firstPaymentDate ? (firstPaymentDate | date : 'mediumDate') : ''" type="text" disabled>
      </mat-form-field>
    </div-->

  </div>

  <h5 class="mb-4">Datos Actuales de su Préstamo:</h5>

  <div class="row">

    <div class="col-md-4">
      <mat-form-field>
        <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
        <input matInput placeholder="Suma Amortizada:" [value]="(paidTotal | number: '.2')" type="text" disabled>
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field>
        <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
        <input matInput placeholder="Suma Pendiente de Amortizar:" [value]="(pendingTotal | number: '.2')" type="text"
          disabled>
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field>
        <input matInput placeholder="Número de Pagos Restantes:" [value]="remainingPayments" type="number" disabled>
      </mat-form-field>
    </div>

  </div>

  <div class="row">
    <div class="col-md-12">

      <table mat-table *ngIf="!loanType" [dataSource]="scheduleDatesValues" class="table border">

        <ng-container matColumnDef="depositDateBiWeek">
          <th mat-header-cell *matHeaderCellDef> Número De Catorcena: </th>
          <td mat-cell *matCellDef="let i = index"> {{i + 1}} </td>
        </ng-container>

        <ng-container matColumnDef="depositDateWeek">
          <th mat-header-cell *matHeaderCellDef> Número De Semana: </th>
          <td mat-cell *matCellDef="let i = index"> {{i + 1}} </td>
        </ng-container>

        <ng-container matColumnDef="totalAmount">
          <th mat-header-cell *matHeaderCellDef> Total: </th>
          <td mat-cell *matCellDef="let element"> {{element.capital | number: '.2-2'}} </td>
        </ng-container>

        <ng-container matColumnDef="paid">
          <th mat-header-cell *matHeaderCellDef> Pagado: </th>
          <td mat-cell *matCellDef="let element">
            <mat-icon>{{element.paid ? 'check' : 'alarm'}}</mat-icon>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedUpFrontColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedUpFrontColumns; let i = index"></tr>

      </table>

      <table mat-table *ngIf="loanType" [dataSource]="scheduleDatesValues" class="table border">

        <!-- depositDate Column -->
        <ng-container matColumnDef="biWeekNumber">
          <th mat-header-cell *matHeaderCellDef> Número Catorcena </th>
          <td mat-cell *matCellDef="let element"> {{element.biWeekNumber}} </td>
        </ng-container>

        <!-- depositDate Column -->
        <ng-container matColumnDef="weekNumber">
          <th mat-header-cell *matHeaderCellDef> Número Semana </th>
          <td mat-cell *matCellDef="let element"> {{ element.weekNumber }} </td>
        </ng-container>

        <!-- depositDate Column -->
        <ng-container matColumnDef="year">
          <th mat-header-cell *matHeaderCellDef> Año </th>
          <td mat-cell *matCellDef="let element"> {{ element.depositDate | date:'yyyy'}} </td>
        </ng-container>

        <!-- capital Column -->
        <ng-container matColumnDef="capital">
          <th mat-header-cell *matHeaderCellDef> Capital </th>
          <td mat-cell *matCellDef="let element">$ {{element.capital | number: '.2-2'}} </td>
        </ng-container>

        <!-- totalAmount Column -->
        <ng-container matColumnDef="capitalAmortization">
          <th mat-header-cell *matHeaderCellDef> Capital Pendiente: </th>
          <td mat-cell *matCellDef="let element">$ {{element.capitalAmortization  | number: '.2-2'}} </td>
        </ng-container>

        <!-- totalAmount Column -->
        <ng-container matColumnDef="interest">
          <th mat-header-cell *matHeaderCellDef> Intereses: </th>
          <td mat-cell *matCellDef="let element">$ {{element.interest  | number: '.2-2'}} </td>
        </ng-container>

        <!-- totalAmount Column -->
        <ng-container matColumnDef="totalAmount">
          <th mat-header-cell *matHeaderCellDef> Total: </th>
          <td mat-cell *matCellDef="let element">$ {{element.total  | number: '.2-2'}} </td>
        </ng-container>

        <ng-container matColumnDef="paid">
          <th mat-header-cell *matHeaderCellDef> Pagado: </th>
          <td mat-cell *matCellDef="let element">
            <mat-icon>{{element.paid ? 'check' : 'alarm'}}</mat-icon>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedFixedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedFixedColumns; let i = index"></tr>

      </table>

    </div>
  </div>

  <div class="my-5 row">
    <div class="col-md-4 offset-md-8">
      <button class="btn btn-outline-secondary btn-block" (click)="cancelSimple(1, null)">Regresar</button>
    </div>
  </div>

  </div>

  <div class="mt-3" *ngIf="showLoanRestructuring">

    <h5 class="mt-1 mb-4">Datos Iniciales de su Préstamo:</h5>

    <div class="row">

      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Importe Inicial:" [value]="(loanCopy.requestedAmount | number: '.2')" type="text" disabled>
        </mat-form-field>
      </div>

    </div>

    <div class="row">

      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Fecha del Primer Descuento:"
            [value]="firstPaymentDate ? (firstPaymentDate | date : 'mediumDate') : ''" type="text" disabled>
        </mat-form-field>
      </div>

    </div>

    <h5 class="mb-4">Datos Actuales de su Préstamo:</h5>

    <div class="row">

      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Suma Amortizada:" [value]="(paidTotal | number: '.2')" type="text" disabled>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Suma Pendiente de Amortizar:" [value]="(pendingTotal )" type="text"
            disabled>
        </mat-form-field>
      </div>

    </div>

    <div class="row">

      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Número de Pagos Restantes:" [value]="remainingPayments" type="text" disabled>
        </mat-form-field>
      </div>

    </div>

    <!--div class="row">

      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Total a Recibir:" [value]="(remainderPayment | number: '.2')" type="text" disabled>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Fecha de Liquidación Via Nomina:"
            [value]="nextPaymentDate ? (nextPaymentDate | date : 'mediumDate') : ''" type="text" disabled>
        </mat-form-field>
      </div>

    </div-->

    <h5 class="mb-4">Datos a Tomar en Cuenta para la Reestructuración:</h5>

    <div class="row">

      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Monto Máximo que puede solicitar en el Nuevo Préstamo:"
            [value]="(retirementLoanParameter.maxLoanAmount(currentEmployee, logicService.shouldCalculateAVGWage(currentEmployee)) | number: '.2')" type="text" disabled>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field>
          <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
          <input matInput
            placeholder="Total De Adeudo Pendiente (Préstamo Caja De Ahorro Retiro):"
            [value]="(pendingTotal)" type="number" disabled>
        </mat-form-field>
      </div>

    </div>

    <div class="row">

      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Máximo de Cuotas para Descuento:" [value]="maxNumberOfPayments"
            type="number" disabled>
        </mat-form-field>
      </div>

    </div>

    <div class="row" onpaste="return false">

      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Monto del Préstamo a solicitar:"
            [(ngModel)]="newLoan.requestedAmount" type="number" min="0"
            onkeypress="return event.charCode >= 48 && event.charCode <= 57">
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Número de Cuotas a Descontar de la Nómina:"
            [(ngModel)]="newLoan.requestedNumberOfPayments" type="number" min="0"
            onkeypress="return event.charCode >= 48 && event.charCode <= 57">
        </mat-form-field>
      </div>

      <div class="col-md-4 center-vertically">
        <button style="margin-bottom: 1.25em;" class="btn btn-block btn-primary " (click)="calculate()">Calcular</button>
      </div>

    </div>

    <div class="row" >

      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Monto a Descontar {{ textWage }}:"
            [value]="discountPerPayment ? (discountPerPayment | number: '.2') : '0'"
            type="text" disabled>
        </mat-form-field>
      </div>

    </div>

    <div class="row" *ngIf="newLoan.scheduleDates.values().length > 0">
      <div class="col-md-12">

        <table mat-table *ngIf="!newLoanType" [dataSource]="newLoan.scheduleDates.values()" class="table border">

          <ng-container matColumnDef="depositDateBiWeek">
            <th mat-header-cell *matHeaderCellDef> Número De Catorcena: </th>
            <td mat-cell *matCellDef="let i = index"> {{i + 1}} </td>
          </ng-container>

          <ng-container matColumnDef="depositDateWeek">
            <th mat-header-cell *matHeaderCellDef> Número De Semana: </th>
            <td mat-cell *matCellDef="let i = index"> {{i + 1}} </td>
          </ng-container>

          <ng-container matColumnDef="totalAmount">
            <th mat-header-cell *matHeaderCellDef> Total: </th>
            <td mat-cell *matCellDef="let element"> {{element.capital | number: '.2-2'}} </td>
          </ng-container>

          <ng-container matColumnDef="paid">
            <th mat-header-cell *matHeaderCellDef> Pagado: </th>
            <td mat-cell *matCellDef="let element">
              <mat-icon>{{element.paid ? 'check' : 'alarm'}}</mat-icon>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedUpFrontColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedUpFrontColumns; let i = index"></tr>

        </table>

        <table mat-table *ngIf="newLoanType" [dataSource]="newLoan.scheduleDates.values()" class="table border">

          <!-- depositDate Column -->
          <ng-container matColumnDef="biWeekNumber">
            <th mat-header-cell *matHeaderCellDef> Número Catorcena </th>
            <td mat-cell *matCellDef="let element"> {{element.biWeekNumber}} </td>
          </ng-container>

          <!-- depositDate Column -->
          <ng-container matColumnDef="weekNumber">
            <th mat-header-cell *matHeaderCellDef> Número Semana </th>
            <td mat-cell *matCellDef="let element"> {{ element.weekNumber }} </td>
          </ng-container>

          <!-- depositDate Column -->
          <ng-container matColumnDef="year">
            <th mat-header-cell *matHeaderCellDef> Año </th>
            <td mat-cell *matCellDef="let element"> {{ element.depositDate | date:'yyyy'}} </td>
          </ng-container>

          <!-- capital Column -->
          <ng-container matColumnDef="capital">
            <th mat-header-cell *matHeaderCellDef> Capital </th>
            <td mat-cell *matCellDef="let element">$ {{element.capital | number: '.2-2'}} </td>
          </ng-container>

          <!-- totalAmount Column -->
          <ng-container matColumnDef="capitalAmortization">
            <th mat-header-cell *matHeaderCellDef> Capital Pendiente: </th>
            <td mat-cell *matCellDef="let element">$ {{element.capitalAmortization  | number: '.2-2'}} </td>
          </ng-container>

          <!-- totalAmount Column -->
          <ng-container matColumnDef="interest">
            <th mat-header-cell *matHeaderCellDef> Intereses: </th>
            <td mat-cell *matCellDef="let element">$ {{element.interest  | number: '.2-2'}} </td>
          </ng-container>

          <!-- totalAmount Column -->
          <ng-container matColumnDef="totalAmount">
            <th mat-header-cell *matHeaderCellDef> Total: </th>
            <td mat-cell *matCellDef="let element">$ {{element.total  | number: '.2-2'}} </td>
          </ng-container>

          <ng-container matColumnDef="paid">
            <th mat-header-cell *matHeaderCellDef> Pagado: </th>
            <td mat-cell *matCellDef="let element">
              <mat-icon>{{element.paid ? 'check' : 'alarm'}}</mat-icon>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedFixedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedFixedColumns; let i = index"></tr>

        </table>

      </div>
    </div>

    <div class="my-5 row">
      <div class="col-md-4 offset-md-4">

        <button class="btn btn-outline-secondary btn-block" (click)="cancel(1, null)">Cancelar</button>
      </div>
      <div class="col-md-4">

        <button class="btn btn-block btn-primary" (click)="saveRestructuredLoan()"
          [disabled]="displaySave">Aceptar</button>
      </div>
    </div>

  </div>

  <div class="mt-3" *ngIf="showLoanAdvancePayment">
    
      <h5 class="mt-1 mb-4">Datos Iniciales de su Préstamo:</h5>
    
      <div class="row">
        <div class="col-md-4">
          <mat-form-field>
            <input matInput placeholder="Importe Inicial:" [value]="loanCopy.requestedAmount.toFixed(2)" type="text" disabled>
          </mat-form-field>
        </div>
      </div>
    
      <div class="row">
    
        <div class="col-md-4">
          <mat-form-field>
            <input matInput placeholder="Cuotas Iniciales De Descuento:" [value]="loanCopy.scheduleDates.values().length" type="text"
              disabled>
          </mat-form-field>
        </div>
    
      </div>
    
      <div class="row">
    
        <div class="col-md-4">
          <mat-form-field>
            <input matInput placeholder="Fecha del Primer Descuento:" [value]="firstPaymentDate ? (firstPaymentDate | date : 'mediumDate') : ''"
              type="text" disabled>
          </mat-form-field>
        </div>
    
      </div>
    
      <h5 class="mb-4">Datos Actuales de su Préstamo:</h5>
    
      <div class="row">
    
        <div class="col-md-4">
          <mat-form-field>
            <input matInput placeholder="Suma Amortizada:" [value]="paidTotal.toFixed(2)" type="text" disabled>
          </mat-form-field>
        </div>
    
        <div class="col-md-4">
          <mat-form-field>
            <input matInput placeholder="Suma Pendiente de Amortizar:" [value]="pendingTotal.toFixed(2)" type="text"
              disabled>
          </mat-form-field>
        </div>
    
      </div>
    
      <div class="row">
    
        <div class="col-md-4">
          <mat-form-field>
            <input matInput placeholder="Número de Pagos Restantes:" [value]="remainingPayments" type="text" disabled>
          </mat-form-field>
        </div>
    
      </div>
    
      <!--h5 class="mb-4">Datos Actuales de su Préstamo:</h5>
    
      <div class="row">
    
        <div class="col-md-4">
          <mat-form-field>
            <input matInput placeholder="Total a Recibir:" [value]="remainderPayment.toFixed(2)" type="text" disabled>
          </mat-form-field>
        </div>
    
        <div class="col-md-4">
          <mat-form-field>
            <input matInput placeholder="Fecha de Liquidación Via Nomina:" [value]="nextPaymentDate ? (nextPaymentDate | date : 'mediumDate') : ''"
              type="text" disabled>
          </mat-form-field>
        </div>
    
      </div-->
    
      <div class="row">
        <div class="col-md-4 offset-md-4">
          <button class="btn btn-outline-secondary btn-block" (click)="cancel(1, null)">Cancelar</button>
        </div>
        <div class="col-md-4">
          <button class="btn btn-block btn-primary" (click)="saveAdvanceLoanPayment()">Aceptar</button>
        </div>
      </div>
    
  </div>
</div>

<ng-template #showRetirementLoanPending>
  <div class="row mt-4 mb-4">
    <div class="col-md-12 text-center noActions">
      <h5 class="mt-1">Solicitud De Préstamo Caja De Ahorro Retiro</h5>
      <mat-icon aria-hidden="true">check</mat-icon>
      <h5>Tu Solicitud Se Encuentra En Revisión</h5>
    </div>
  </div>
  <div class="my-5 row">
    <div class="col-md-4 offset-md-4">
      <button class="btn btn-outline-secondary btn-block" (click)="cancelSimple(1, null)">Regresar</button>
    </div>
  </div>
</ng-template>